import { useContractReads } from 'wagmi'
import { CHAIN_ID, CONTRACTS, LockType } from './config'
import { lockV2Abi, lockV3Abi } from './server/abis'

export type Fees = { native?: bigint; cbon?: bigint; loading: boolean; failed: boolean }

/** The fee for a new lock, read live from the locker (never a constant of the page): BNB, and CBON for those who pay in CBON. */
export function useLockFees(type: LockType): Fees {
  const address = CONTRACTS[type].address as `0x${string}`
  const abi = (type === 'v3' ? lockV3Abi : lockV2Abi) as any
  const { data, isLoading, isError } = useContractReads({
    chainId: CHAIN_ID,
    contracts: [
      { address, abi, functionName: 'priceInNative' },
      { address, abi, functionName: 'priceInCbon' },
    ] as any,
    staleTime: 30_000,
  } as any)
  const [n, c] = (data ?? []) as Array<{ status: string; result?: bigint }>
  return { native: n?.status === 'success' ? n.result : undefined, cbon: c?.status === 'success' ? c.result : undefined, loading: isLoading, failed: isError || (data !== undefined && (n?.status !== 'success' || c?.status !== 'success')) }
}
